import CircleIOutlined from './src/circle-i-outlined';
export default CircleIOutlined;